'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var PX_TO_MULTIPLIER = {
  '0': 0,
  '1': 0.125,
  '2': 0.25,
  '4': 0.5,
  '5': 0.625,
  '6': 0.75,
  '7': 0.875,
  '8': 1,
  '9': 1.125,
  '10': 1.25,
  '11': 1.375,
  '12': 1.5,
  '15': 1.875,
  '16': 2,
  '30': 3.5,
  '32': 4,
  '34': 4.25,
  '36': 4.5,
  '38': 4.75,
  '40': 5
};

exports.PX_TO_MULTIPLIER = PX_TO_MULTIPLIER;
